import React from 'react';
import { ConnectionStatusEnumType, ConnectionStatusSourceEnumType } from '@mark43/cad-api';

export type ConnectionStatusContextValue = Record<
    ConnectionStatusSourceEnumType,
    ConnectionStatusEnumType
>;

export const defaultConnectionStatusContextValue: ConnectionStatusContextValue = {
    SOCKET: 'ONLINE',
    INTERNET: 'ONLINE',
    MARK43_PING: 'ONLINE',
    DNS_RESOLUTION: 'ONLINE',
    FARO: 'ONLINE',
};

export const ConnectionStatusContext = React.createContext<ConnectionStatusContextValue>(
    defaultConnectionStatusContextValue
);
